import { ArrowLeft, CloudOff } from "lucide-react";
import { InvoraLogo } from "@/components/common/invora-logo";
import { Button } from "@/components/ui/button";
import { platformHomeUrl } from "@/hooks/use-site";

/**
 * An address that is not a registered (or active) business, e.g.
 * zoho.localhost:5173. Deliberately no sign-in form and no detail about why.
 */
export function SiteUnavailable() {
  return (
    <div className="flex min-h-svh flex-col bg-background">
      <header className="px-5 py-4 sm:px-8">
        <a href={platformHomeUrl()} aria-label="Invora home">
          <InvoraLogo size="sm" />
        </a>
      </header>
      <main className="flex flex-1 flex-col items-center justify-center px-4 pb-24 text-center">
        <div className="mb-5 flex size-14 items-center justify-center rounded-2xl bg-muted">
          <CloudOff className="size-6 text-muted-foreground" aria-hidden />
        </div>
        <h1 className="text-2xl font-semibold tracking-tight sm:text-3xl">This site is unavailable</h1>
        <p className="mt-3 max-w-md text-muted-foreground">
          There is no business at <span className="font-medium text-foreground">{window.location.host}</span>. Check the address, or ask the business for
          the correct link.
        </p>
        <Button asChild variant="outline" className="mt-7">
          <a href={platformHomeUrl()}>
            <ArrowLeft aria-hidden /> Go to Invora
          </a>
        </Button>
      </main>
    </div>
  );
}

/** The API could not be reached at all. */
export function SiteConnectionError({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-3 px-4 text-center">
      <CloudOff className="size-8 text-muted-foreground" aria-hidden />
      <h1 className="text-lg font-semibold">Could not connect</h1>
      <p className="max-w-sm text-sm text-muted-foreground">The server could not be reached. Check your connection and try again.</p>
      <Button variant="outline" onClick={onRetry}>
        Try again
      </Button>
    </div>
  );
}
